<template>
  <div>
    <a-modal
      :maskClosable="false"
      title="续费"
      :width="600"
      destroyOnClose
      :visible="visible"
      :confirmLoading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form 
        :form="form"
        :autoFormCreate="(form)=>{this.form = form}">
        <a-form-item
          label="客户简称"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }">
          <span>{{ tenant.tenancyName }}</span>
        </a-form-item>
        <a-form-item
          label="客户名称"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }">
          <span>{{ tenant.name }}</span>
        </a-form-item>
        <a-form-item
          label="价格"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }">
          <span>{{ tenant.price }}</span>
        </a-form-item>
        <a-form-item
          label="续费年限"
          :labelCol="{ span:5 }"
          :wrapperCol="{ span:17 }">
          <a-select
            style="width:250px"
            v-model="years"
          >
            <a-select-option :value="1">一年</a-select-option>
            <a-select-option :value="2">二年</a-select-option>
            <a-select-option :value="3">三年</a-select-option>
            <a-select-option :value="5">五年</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="应付费用"
          :labelCol="{ span:5 }"
          :wrapperCol="{ span:17 }">
          {{ years*tenant.price }}
        </a-form-item>
        <a-form-item
          label="支付方式"
          :labelCol="{ span:5 }"
          :wrapperCol="{ span:17 }">
          <a-select
            style="width:250px"
            v-model="payType"
          >
            <a-select-option :value="0">支付宝</a-select-option>
            <a-select-option :value="1">微信</a-select-option>
            <a-select-option :value="2">银联</a-select-option>
            <a-select-option :value="3">其它</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import {mapState,mapActions} from 'vuex'
import tenantApi from '@/api/tenant'
export default {
  model: {
    prop: 'visible',
    event: 'change'
  },
  props:{
    visible:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      confirmLoading:false,
      form:null,
      years:1,
      payType:0
    }
  },
  methods:{
    ...mapActions('tenant',['updateOrAdd']),
    async handleOk(){
      await tenantApi.payment({
        tenantId:this.tenant.id,
        payTime:new Date(),
        payAmount:this.years*this.tenant.price,
        years:this.years,
        payType:this.payType
      })
      this.$message.success('续费成功')
      this.$emit('change',false)
    },
    handleCancel(){
      this.$emit('change',false)
    }
  },
  computed:mapState({
    tenant:state=>state.tenant.editTenant
  })
}
</script>


